/**
 * external dependencies
 */
import { TabulatorFull, Options, CellComponent, ColumnDefinition } from 'tabulator-tables';

/**
 * internal dependencies
 */
import useAuth from '../../hooks/auth-hooks';
import { ICustomers } from '../../models/customer.interface';
import { tableSearchInput } from './table-helpers';

import GetCustomers from '../../routes/get-customers';

/**
 * Displays the customer table on the customers page
 * 
 * @returns void
 */
export const customerListTable = async () => {
  const customerTable = document.querySelector('.aafp_customer-list') as HTMLElement;
  if(!customerTable) return;

  const { body } = await GetCustomers();

  parseCustomerData( body, customerTable );
}

/**
 * Parses the customer data and displays it in the table
 * 
 * @param {object[]} data the api response data
 * @param {HTMLElement} element the HTML element to display the table in
 * 
 * @returns void
 */
const parseCustomerData = ( data: ICustomers[], element: HTMLElement ) => {
  const { accessType } = useAuth()!;

  /**
   * Formats the link button for the user
   * 
   * @param {CellComponent} cell the cell component
   * @param {any} formatterParams the formatter parameters 
   * 
   * @returns string
   */
  const link_button = (cell: CellComponent, formatterParams: any) => {
    let data = cell.getData() as ICustomers;
    let userPrev = accessType === 'E' ? 'Edit' : 'View';
    return `<a class='aafp_btn-table btn_theme-primary'' 
              href='/customers/customer-edit/?userID=${data.customerId}' 
              data-toggle="tooltip" 
              data-placement="bottom" 
              title="${userPrev} Customer ${data.customerName}"
            >
              <i class="${userPrev === 'Edit' ? 'fas fa-pen' : 'far fa-eye'}"></i>
            </a>`;
  }

  /**
   * Formats the status of the customer
   * 
   * @param {CellComponent} cell the cell component
   * @param {any} formatterParams the formatter parameters
   * 
   * @returns string
   */
  const statusFormat = (cell: CellComponent, formatterParams: any) => {
    let data = cell.getData() as ICustomers;
    let status = data.status;
    let statusClass = status === 1 ? 'aafp_status-active' : 'aafp_status-inactive';
    let statusText = status === 1 ? 'Active' : 'Inactive';
    return `<span class="${statusClass}">${statusText}</span>`;  
  } 

  const columnDefinition: ColumnDefinition[] = [
    { title: "customerId", field: "customerId", visible: false },
    { title: 'Name', field: 'customerName', cssClass: "aafp_column-", resizable: false, vertAlign: 'middle' },
    { title: 'Account Number', field: 'accountNumber', cssClass: "aafp_column-7", resizable: false, vertAlign: 'middle' },
    { title: 'Partner', field: 'partnerName', cssClass: "aafp_column-7", resizable: false, vertAlign: 'middle' },
    { title: 'Status', field: 'status', formatter: statusFormat, cssClass: "aafp_column-button-wide", resizable: false, width: 40, vertAlign: 'middle' },
    { title: '', field: "LinkButton", formatter: link_button, cssClass: "aafp_column-button", hozAlign: 'center', width: 40, headerSort: false, resizable: false }
  ];

  const options: Options = {
    index:"customerId", 
    data: data,
    placeholder: "No Data Available",
    placeholderHeaderFilter: "No Matching Data",
    pagination: true,
    paginationMode: "local",
    paginationSize: 10,
    paginationSizeSelector: [25, 50, 75],
    paginationCounter: "rows",
    selectable: false,
    downloadRowRange: 'visible',
    columns: columnDefinition
  };

  const customerTableGrid = new TabulatorFull(element, options);
  const terminalListSort = document.querySelector('#aafp_customer-list-sort') as HTMLInputElement;
  tableSearchInput(terminalListSort, customerTableGrid);
}